import type { ICSTabBase } from 'libs/design-system/src/types/content_switchers/tab_base';
import styles from "./tab-base.module.scss";

export const TabBase = ({
  id,
  leadingIcon,
  trailingIcon,
  active = false,
  disabled = false,
  text,
  onClickHandler,
}: ICSTabBase) => {

  return (
    <div
      id={id}
      tabIndex={0}
      className={styles["tab-base"]}
      data-cs-tab-base-active={active}
      data-cs-tab-base-disabled={disabled}
      onClick={onClickHandler}
    >
      {leadingIcon}
      {text}
      {trailingIcon}
    </div>
  )
};